var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"80%"},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('v-card',{staticClass:"photo"},[_c('v-img',{attrs:{"contain":"","src":_vm.uri}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }